import React from 'react';
import StudentLearningHub from '../student/StudentLearningHub';

// Renders the Student & Parent Web Learning Hub experience as-is within the Coaching
// profile. Header + Footer switch automatically based on the /coaching/* prefix.
export default function CoachingLearningHub() {
  return <StudentLearningHub />;
}
